import { createSelector } from 'reselect';

import { EmptyArray, EmptyObject } from '../../../Resources/EmptyDefaults';

import {
  DEFAULT_FILTERS_QUICKBOOKS_ONLINE,
  DEFAULT_INCOME_ACCOUNT_NAME,
  PROCESS_STATUSES_QUICKBOOKS_ONLINE,
  QUICKBOOKS_ONLINE_ERROR_FILTER_NAMESPACE,
  QUICKBOOKS_ONLINE_ERROR_SORT_NAMESPACE,
  QUICKBOOKS_ONLINE_IMPORT_FROM_DATE,
  QUICKBOOKS_ONLINE_NAMESPACE,
  SUBTYPE_SALES_OF_PRODUCT_INCOME,
} from './Constants';

export type State = {
  quickBooksOnline: Record<string, unknown>;
};

export const getEmptyObject = createSelector(
  (_) => _,
  (_) => EmptyObject
);

export const getEmptyArray = createSelector(
  (_) => _,
  (_) => EmptyArray
);

export const getQuickbooksOnlineData = (state: State) => state[QUICKBOOKS_ONLINE_NAMESPACE] || EmptyObject;

export const getErrorTableSort = createSelector(
  getQuickbooksOnlineData,
  (data) => data[QUICKBOOKS_ONLINE_ERROR_SORT_NAMESPACE] || EmptyObject
);

export const getErrorFilters = createSelector(
  getQuickbooksOnlineData,
  (data) => data[QUICKBOOKS_ONLINE_ERROR_FILTER_NAMESPACE] || EmptyObject
);

export const getQuickbooksOnlineImportFromDate = createSelector(
  getQuickbooksOnlineData,
  (data) => data[QUICKBOOKS_ONLINE_IMPORT_FROM_DATE] || EmptyObject
);

export const getErrorFiltersWithDefaults = createSelector(
  getQuickbooksOnlineData,
  (_: unknown, customDefaults: Record<string, unknown>) => customDefaults,
  (data, customDefaults) =>
    data[QUICKBOOKS_ONLINE_ERROR_FILTER_NAMESPACE] || { ...DEFAULT_FILTERS_QUICKBOOKS_ONLINE, ...customDefaults }
);

export const processInProgress = (status: string) => {
  const { pendingStart, running } = PROCESS_STATUSES_QUICKBOOKS_ONLINE;

  return status === pendingStart || status === running;
};

export const defaultIncomeAccount = (accounts: Array<Record<string, unknown>>) => {
  const defaultAccountByName = accounts.find(
    (account: Record<string, unknown>) => account.name === DEFAULT_INCOME_ACCOUNT_NAME
  );
  if (defaultAccountByName) return defaultAccountByName;

  const defaultAccountBySubtype = accounts.find(
    (account) => account.account_sub_type === SUBTYPE_SALES_OF_PRODUCT_INCOME
  );

  return defaultAccountBySubtype || accounts[0];
};
